<template lang="html">
  <section class="aDemo">
    <br>
    <h3>This demo has not been implemented yet.</h3>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'generic',
    props: {nexmo:{
            type: Object,
            required: false
        }},
}
</script>

<style scoped lang="scss">
</style>